<template>
  <OneCTText
    :background-color="mgnlProps.backgroundColor"
    :top-title="mgnlProps.topTitle"
    :title="mgnlProps.title"
    :sub-text="mgnlProps.subText"
    :slides="mgnlProps.slides"
    :data-ab-id="mgnlProps?.dataABId"
    :enable-legal-disclaimer="mgnlProps.enableLegalDisclaimer"
    :legal-text="mgnlProps.legalText"
    :legal-title="mgnlProps.legalTitle"
    :title-or-subtitle="mgnlProps.titleOrSubtitle"
  />
</template>

<script lang="ts" setup>
import { OneCTTextBuilder, WrapperProps } from './OneCTText.model';
import OneCTText from './OneCTText.vue';
import useTeaser from '~/composables/useTeaser/useTeaser';

const props = defineProps(WrapperProps);
const { transformTeaserData } = useTeaser();
const mgnlProps = transformTeaserData(OneCTTextBuilder.build(props));
</script>
